module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/candy-two-5ce4bb4cee5b4222e124db7c05bc6ae7.png";